import React from 'react'
import { cn } from '../../utils/utils'

const Badge = React.forwardRef(({ className, variant = "default", ...props }, ref) => {
  const variants = {
    default: "bg-white/20 text-black border-white/30",
    success: "bg-emerald-500/20 text-black border-emerald-500/30",
    warning: "bg-amber-500/20 text-black border-amber-500/30",
    destructive: "bg-red-500/20 text-black border-red-500/30",
    secondary: "bg-slate-500/20 text-black border-slate-500/30"
  }

  return (
    <div
      ref={ref}
      className={cn(
        "inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 backdrop-blur-sm",
        variants[variant],
        className
      )}
      {...props}
    />
  )
})
Badge.displayName = "Badge"

export { Badge }